import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getReceiving = async (params: object) => {
  return await GET({ url: Api.getReceiving, params, showError: false })
}
